export default __webpack_public_path__ + "static/media/trafic-gallery-1.86c3cd01.jpg";